import storage from 'redux-persist/lib/storage';

const storageLocal = storage;

export default storageLocal;
